export default "__VITE_ASSET__DJXGWRV1__"